export default __webpack_public_path__ + "static/media/Openscreen.e04bba3b.png";